import { BsChatDots } from 'react-icons/bs'
import { useHref, useLocation } from 'react-router-dom'

import { DataPackages } from '@piv/lib/rest-queries'
import { environment } from '@piv/portal/environment'
import { AnchorButton } from '@piv/portal/primitives/Buttons'

interface Props {
  dataPackage: DataPackages.Types.GetResponse['packages'][0]
}

export function MailToLink({ dataPackage }: Props) {
  const location = useLocation()
  const href = useHref(location)

  return (
    <AnchorButton
      href={
        'mailto://' +
        encodeURIComponent(environment.misc.salesEmailAddress) +
        '?subject=' +
        encodeURIComponent(
          `Request for information on data package: "${dataPackage.dataPackage.displayName}"`
        ) +
        '&body=' +
        encodeURIComponent(
          `I'm interested in this data package: ${
            window.location.origin + href
          }`
        )
      }
      iconPosition="left"
      icon={<BsChatDots strokeWidth={1} />}
    >
      Find out more
    </AnchorButton>
  )
}
